import { render, staticRenderFns } from "./PoolTable.vue?vue&type=template&id=0f345a84"
import script from "./PoolTable.vue?vue&type=script&lang=js"
export * from "./PoolTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports